export default "__VITE_ASSET__b78933bc__"